import { api } from 'redux/api/index.api';

export const automationsApi = api.injectEndpoints({
  endpoints: builder => ({
    fetchKolimmoUsers: builder.query({
      query: ({ organizationId }) => ({
        url: `/organizations/${organizationId}/automations/settings/kolimmo/users`,
        method: 'GET',
      }),
      transformResponse: response => response.kolimmo_user_ids ?? [],
      providesTags: (result, error, { organizationId }) => [
        { type: 'KolimmoUsers', id: organizationId },
      ],
    }),
    setKolimmoUsers: builder.mutation({
      query: ({ organizationId, userIds }) => ({
        url: `/organizations/${organizationId}/automations/settings/kolimmo/users/add`,
        method: 'POST',
        body: {
          kolimmo_user_ids: userIds,
        },
      }),
      invalidatesTags: (result, error, { organizationId }) => [
        { type: 'KolimmoUsers', id: organizationId },
      ],
    }),
    fetchKolimmoUserStatus: builder.query({
      query: ({ organizationId, userId }) => ({
        url: `/organizations/${organizationId}/automations/settings/kolimmo/users/${userId}/exists`,
        method: 'GET',
      }),
    }),
    fetchAutomationsForStatus: builder.query({
      query: ({ organizationId, formId, statusId }) => ({
        url: `/organizations/${organizationId}/automations/forms/${formId}/statuses/${statusId}`,
        method: 'GET',
      }),
      transformResponse: response => response.automations ?? [],
      providesTags: (result, error, { organizationId, formId, statusId }) => [
        { type: 'Automations', id: `${organizationId}-${formId}-${statusId}` },
      ],
    }),
    removeKolimmoUsers: builder.mutation({
      query: ({ organizationId, userIds }) => ({
        url: `/organizations/${organizationId}/automations/settings/kolimmo/users/remove`,
        method: 'POST',
        body: {
          kolimmo_user_ids: userIds,
        },
      }),
      invalidatesTags: (result, error, { organizationId }) => [
        { type: 'KolimmoUsers', id: organizationId },
      ],
    }),
  }),
  overrideExisting: 'throw',
});

export const {
  useFetchKolimmoUsersQuery,
  useSetKolimmoUsersMutation,
  useRemoveKolimmoUsersMutation,
  useFetchKolimmoUserStatusQuery,
  useFetchAutomationsForStatusQuery,
  useLazyFetchAutomationsForStatusQuery,
} = automationsApi;
